import { schema } from "normalizr";

import { unitListing } from "shared/state/UnitListing/schema";

export const deal = new schema.Entity("deal", {
  unitListing,
});
export const dealList = [deal];
